import { defineMessages } from 'react-intl';

export const commonMessage = defineMessages({
    home: 'Home',
    admins: 'Admin',
    adminsLeader: 'Admins Leader',
    news: 'News',
    category: 'Category',
    newsCategory: 'News Category',
    transactionCategory: 'Transaction Category',
    previewFailed: 'Preview failed',
    title: 'Title',
    status: 'Trạng thái',
    username: 'Username',
    fullName: 'Full name',
    phone: 'Phone',
    group: 'Group',
    createdDate: 'Ngày tạo',
    modifiedDate: 'Modified Date',
    userAdmin: 'Admin',
    userAdminLeader: 'Admins Leader',
    profile: 'Hồ sơ',
    avatar: 'Avatar',
    currentPassword: 'Mật khẩu hiện tại',
    newPassword: 'Mật khẩu mới',
    validatePassword: 'Password must be at least 6 characters',
    confirmPassword: 'Confirm password',
    passwordNotMatch: 'Password not match',
    password: 'Password',
    confirm: 'Xác nhận',
    login: 'Đăng nhập',
    email: 'Email',
    name: 'Name',
    description: 'Description',
    groupPermission: 'Nhóm quyền',
    listSetting: 'List Setting',
    settingValue: 'Value',
    groupName: 'Tên nhóm',
    isEditable: 'Is Editable',
    isSystem: 'Is System',
    settingKey: 'Setting Key',
    address: 'Địa chỉ',
    ward: 'Ward',
    district: 'District',
    province: 'Province',
    nation: 'Nation',
    village: 'Village',
    kind: 'Loại',
    user: 'Users',
    birthday: 'Ngày sinh',
    Name: 'Tên',
    Province: 'Province',
    District: 'District',
    Village: 'Village',
    Nation: 'Nation',
    showSystemSettings: 'Show system settings',
    hideSystemSettings: 'Hide system settings',
    timeZone: 'Timezone',
    money: 'Money',
    system: 'System',
    department: 'Department',
    transaction: 'Transaction',
    dateCreated: 'Created Date',
    state: 'Tình trạng',
    note: 'Note',
    service: 'Service',
    repeat: 'Nhắc lại',
    numberOfDueDays: 'Number Of Due Days',
    document: 'Document',
    inputUrl: 'Nhập đường dẫn tài liệu',
    nameUrl: 'Tên tài liệu',
    host: 'Host',
    port: 'Port',
    privateKey: 'Private Key',
    deleteAll: 'Delete All',
    readAll: 'Read All',
    all: 'All',
    unRead: 'Unread',
    userNotification: 'User Notification',
    markAsRead: 'Đánh dấu đã đọc',
    paymentPeriod: 'Payment Period',
    transactionDate: 'Transaction date',
    reject: 'Reject',
    recalculate: 'Recalculate paymnet period',
    approve: 'Approve',
    organization: 'Organization',
    logo: 'Logo',
    project: 'Project',
    task: 'Task',
    checkDone: 'Check done',
    decodeKey: 'Decode key',
    stringEncode: 'String for encoding',
    stringDecode: 'String for decoding',
    ssh: 'SSH',
    debit: 'Debit',
    Url: 'URL',
    AccountProvidedBy: 'Account Provided By',
    customer: 'Customer',
    location: 'Location',
    hotLine: 'Hot line',
    serverProvider: 'Server Provider',
    dbConfig: 'DB Config',
    tenantId: 'Tenant Id',
    tenantCurrent: 'Tenant current',
    customerName: 'Customer name',
    count: 'Count',
    subject: 'Môn học',
    subjectName: 'Tên môn học',
    users: 'người dùng',
    lectureName: 'Tên bài học',
    lecture: 'Bài học',
    course: 'Khóa học',
    courseName: 'Tên khóa học',
    registration: 'Đăng ký',
    registrationMessage: 'Ghi chú',
    rating: 'Đánh giá',
    star: 'Số sao',
    ratingContent: 'Nội dung đánh giá',
    company: 'Công ty',
    companyName: 'Tên công ty',
    price: 'Giá',
    classroom: 'Lớp học',
    startDate: 'Ngày bắt đầu',
    endDate: 'Ngày kết thúc',
    endDateAfterStartDate: 'Ngày kết thúc phải sau ngày bắt đầu',
    totalTimeline: 'Tổng thời lượng',
    shortDescription: 'Mô tả ngắn',
    syllabus: 'Giáo trình',
    syllabusName: 'Tên giáo trình',
    timeline: 'Thời lượng',
    syllabusKindSession: 'Buổi học',
    uploadSuccess: 'Upload file thành công',
    uploadInvalidFormat: 'File upload không hợp lệ',
    otp: 'OTP',
    authentication: 'Xác thực hai lớp',
    synchronize: 'Đồng bộ',
    accountGroupName: 'Tên nhóm tài khoản',
    accountGroupPermission: 'Nhóm quyền tài khoản',
    accountBook: 'Nhóm tài khoản',
    viewDetails: 'Xem chi tiết',
    detail: 'Chi tiết',
    account: 'Tài khoản',
    required: 'Bắt buộc',
    noData: 'Không có dữ liệu',
    role: 'Vai trò',
    phoneNumber: 'Số điện thoại',
    copy: 'Sao chép',
    copySuccessfully: 'Sao chép thành công',
    restaurant: 'Nhà hàng',
    restaurantName: 'Tên nhà hàng',
    device: 'Thiết bị',
    deviceName: 'Tên thiết bị',
    posId: 'Deive ID',
    deviceType: 'Loại thiết bị',
    expireDate: 'Ngày hết hạn',
    log: 'logs',
    changeContent: 'Nội dung thay đổi',
    id: 'ID',
    time :' Thời gian',
    mentor: 'Mentor',
    position: 'Vị trí',
    student: 'Học viên',
    addNew: 'Thêm mới',
    update: 'Cập nhật',
    cancel: 'Hủy',
    confirmCancel: 'Xác nhận hủy',
    confirmCancelContent: 'Bạn có chắc chắn muốn hủy?',
    yes: 'Đồng ý',
    no: 'Không',
    addNewSuccess: 'Thêm mới {objectName} thành công',
    updateSuccess: 'Cập nhật {objectName} thành công',
    editObject: 'Chỉnh sửa {objectName}',
    addNewObject: 'Thêm mới {objectName}',
    reportTopCourse: 'Top khóa học',
    reportTopCourseTotalStudents: 'Số học viên',
    report: 'Báo cáo',
    topStudent: 'Top học viên',
    totalEnrolledClasses: 'Số lớp đã đăng ký',
    exportExcel: 'Xuất Excel',
    exportExcelFailed: 'Xuất Excel thất bại',
});
